import {
  Home,
  Shield,
  Receipt,
  FileSignature,
  PiggyBank,
  BadgeCheck,
  AlertTriangle,
  Zap,
  FileText,
  Hammer,
  FileBadge,
  TrendingUp,
  Lock,
  Users,
  Baby,
  Megaphone,
  HeartHandshake,
  Landmark,
  ShieldOff,
  CircleHelp,
} from "lucide-react";

export const ICONS = {
  Home,
  Shield,
  Receipt,
  FileSignature,
  PiggyBank,
  BadgeCheck,
  AlertTriangle,
  Zap,
  FileText,
  Hammer,
  FileBadge,
  TrendingUp,
  Lock,
  Users,
  Baby,
  Megaphone,
  HeartHandshake,
  Landmark,
  ShieldOff,
};

export function getCheckerIcon(name) {
  return ICONS[name] || CircleHelp;
}

export const SEVERITY = {
  critical: { label: "Kritiek", color: "#EF4444", bg: "rgba(239,68,68,0.10)", text: "#991B1B" },
  high: { label: "Hoog", color: "#F97316", bg: "rgba(249,115,22,0.10)", text: "#9A3412" },
  medium: { label: "Aandacht", color: "#F59E0B", bg: "rgba(245,158,11,0.12)", text: "#92400E" },
  low: { label: "Info", color: "#3B82F6", bg: "rgba(59,130,246,0.10)", text: "#1E40AF" },
  ok: { label: "Oké", color: "#10B981", bg: "rgba(16,185,129,0.10)", text: "#065F46" },
};
